import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { ContactResponse } from "../../../types/common";
import utilitiesApi from "../../../api/utilities";


export const getContactByAccountName = createAsyncThunk<
    ContactResponse,
    string,
    { state: RootState }
>(
    "accountInfos/getByAccountName",
    async (accountName, { getState }) => {
        const cached = getState().accountInfos.find(
            (it) => it.accountName === accountName
        );
        if (cached) return cached;
        const res = await utilitiesApi.partyInfoByAccount(accountName);
        return res;
    }
);

export const getContactsByAccountNames = createAsyncThunk<
    ContactResponse[],
    string[],
    { state: RootState }
>(
    "accountInfos/getsByAccountName",
    async (accountNames, { getState }) => {
        const cachedByName = new Map(
            getState().accountInfos.map((it) => [it.accountName, it])
        );
        const cachedHits: ContactResponse[] = [];
        const missing: string[] = [];
        for (const name of accountNames) {
            const hit = cachedByName.get(name);
            if (hit) {
                cachedHits.push(hit);
            } else {
                missing.push(name);
            }
        }
        if (missing.length === 0) return cachedHits;
        const fetched = await utilitiesApi.partyInfosByAccount(missing);
        return [...cachedHits, ...fetched];
    }
);